import React from 'react';
import { Button } from 'antd';
import { FaPlus } from 'react-icons/fa';
import { useSearchParams } from 'react-router-dom';
import './moduleConfigPlaceholder.less';

const ModuleConfigPlaceholder: React.FC = () => {
  const [searchParams] = useSearchParams();

  if (searchParams.get('editMode') !== 'true') {
    return null;
  }

  return (
    <div id="Empty-Module-wrapper" className="no-components-wrapper EDIT">
      <div
        onClick={() => {
          console.log('Add Module button clicked');
          window.parent.postMessage(
            { type: 'AddModule', message: { index: 0 } },
            '*'
          );
        }}
        className="no-components-edit-button EDIT-BUTTON"
      />
      <div className="no-components-content">
        <h4 className="no-components-title">
          No components, Please add components
        </h4>
        <Button
          className="no-components-button btn-style-5"
          type="primary"
          icon={<FaPlus />}
        >
          Add New Module
        </Button>
      </div>
    </div>
  );
};

export default ModuleConfigPlaceholder;
